import React, {useState} from "react";
import {Button, Col, DatePicker, Form, Row, Select} from "antd";
import PropTypes from "prop-types";

import InputMoney from "./InputMoney";
import {getActiveAccount} from "../../lib/activeMember";
import {dateFormat} from "../../lib/time";
import {createCharge} from "../../helpers/billing";
import {messageType, showMessages} from "../../helpers/message";
import {formInCardLayout, formItemFullWidth} from "../../assets/styles";
import TaxCheckboxesInForm from "./TaxCheckboxesInForm";
import {loadAccountInfoErrorText, greaterThanOrEqualZero} from "../../helpers/text";

const {Option} = Select;

const CreditCreateForm = (props) => {
    const [loading, setLoading] = useState(false);

    // region form functions
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        const amount = Math.abs(values['Amount']) * -1;

        const chargedAt = values['Date'].format('YYYY-MM-DD HH:mm:ssZZ');
        const type = values['Type'];
        const taxes = values['Taxes'];

        const data = {chargedAt, amount, type, taxes};

        try {
            setLoading(true);
            let account = getActiveAccount();
            if (account === null) {
                throw new Error(loadAccountInfoErrorText);
            }

            await createCharge(account.id, null, data);
            showMessages('The amount has been applied and is now reflected in the account balance.',
                messageType.success);
            setLoading(false);
            form.resetFields();

            props.toggleRefreshBalances(true);
        } catch (error) {
            showMessages(error.message, messageType.error);
            setLoading(false);
        }
    };

    //endregion

    return (
        <Form
            form={form}
            layout="vertical"
            name="charge-create"
            onFinish={handleFinish}
            {...formInCardLayout}
        >
            <Row>
                <Col xs={24} lg={12}>
                    <Form.Item
                        name="Date"
                        label="Date"
                        rules={[{type: 'object', required: true}]}
                    >
                        <DatePicker
                            placeholder="DD MM YYYY"
                            format={dateFormat}
                            style={{...formItemFullWidth}}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item
                name="Type"
                label="Type"
                rules={[{type: 'string', required: true}]}
            >
                <Select>
                    <Option value="adjustment">Adjustment</Option>
                    <Option value="fee">Fee</Option>
                    <Option value="fine">Fine</Option>
                    <Option value="membership">Membership</Option>
                </Select>
            </Form.Item>
            <Form.Item
                name="Amount"
                label="Amount (before tax)"
                rules={[{type: 'number', required: true, min: 0}]}
                help={greaterThanOrEqualZero}
            >
                <InputMoney />
            </Form.Item>
            <TaxCheckboxesInForm taxes={props.taxes} disabled={false}/>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Apply to Account
                </Button>
            </Form.Item>
        </Form>
    );
}

export default CreditCreateForm;

CreditCreateForm.propTypes = {
    taxes: PropTypes.array.isRequired,
    toggleRefreshBalances: PropTypes.func.isRequired,
};
